<body style="background-color:#FFF;">
    <img src="assets/images/info_bg.png" class="bg">
    <div class="infograph_site">
        <div class="infograph" align="left">

            <!--top section-->
            <div class="top_info_sec">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="infograph_stats">
                            <div class="infograph_stat_single">
                                <div class="infograph_stat_title" [innerHtml]="summary.all"></div>
                                <div class="infograph_stat_meta">Mentions</div>
                            </div>
                            <div class="infograph_stat_single">
                                <div class="infograph_stat_title infograph_stat_pos" [innerHtml]="summary.positive"></div>
                                <div class="infograph_stat_meta">Positive mentions</div>
                            </div>
                            <div class="infograph_stat_single">
                                <div class="infograph_stat_title infograph_stat_neg" [innerHtml]="summary.negative"></div>
                                <div class="infograph_stat_meta">Negative mentions</div>
                            </div>
                        </div>

                        <div class="sub-section">
                            <div class="infograph_subtitle">The most active categories</div>
                            <!--top_categories-->
                            <div class="results_type" *ngFor="let sm of top_categories">
                                <div *ngIf="sm.value != 'denied'">
                                    <p>{{sm.category}}</p><h5 [innerHtml]="sm.value"></h5>
                                    <div class="progress">
                                        <div class="progress-bar" role="progressbar" style="width: {{sm.percentage}}%" aria-valuenow="sm.percentage" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col-lg-6">

                        <div class="sub-section">
                            <div class="infograph_subtitle">The most influential</div>
                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <td width="16%" valign="top" *ngFor="let influential of influential_mentions;">
                                            <div class="infograph_user" align="center">
                                                <a href="{{influential.profile_link}}">
                                                    <div><img src="assets/images/infograph_user.png" width="30"></div>
                                                    <div>{{influential.name}}</div>
                                                </a>
                                                <div class="infograph_user_service text-capitalize">
                                                    <!--<i class="fa fa-twitter"></i>-->
                                                    {{influential.mchannel}}</div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="sub-section">
                            <div class="infograph_subtitle">The most active</div>

                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <td width="16%" valign="top" *ngFor="let active of active_mentions;">
                                            <div class="infograph_user" align="center">
                                                <a href="{{active.profile_link}}">
                                                    <div><img src="assets/images/infograph_user.png" width="30"></div>
                                                    <div>{{active.name}}</div>
                                                </a>
                                                <div class="infograph_user_service text-capitalize">
                                                    <!--<i class="fa fa-twitter"></i>-->
                                                    {{active.mchannel}}</div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>

                    </div>
                </div>
            </div>



            <!--bottom section-->
            <div class="bottom_info_sec">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="sub-section">
                            <div class="infograph_subtitle">Number of mentions</div>
                            <canvas baseChart 
                                    [datasets]="lineChartData" 
                                    [options]="lineChartOptions"
                                    [legend]="lineChartLegend" 
                                    [chartType]="lineChartType" 
                                    [plugins]="lineChartPlugins">
                            </canvas>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="sub-section">
                            <div class="infograph_subtitle">Sentiment</div>
                            <canvas baseChart 
                                    [datasets]="sentimantLineChartData" 
                                    [options]="lineChartOptions"
                                    [legend]="lineChartLegend" 
                                    [chartType]="lineChartType" 
                                    [plugins]="lineChartPlugins">
                            </canvas>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="sub-section">
                            <div class="infograph_subtitle">Source types</div>
                            <canvas baseChart 
                                    [data]="doughnutChartdata"
                                    [labels]="doughnutChartLabels"
                                    [colors]="doughnutChartColors"
                                    [legend]="doughnutChartLegend"
                                    [options]="doughnutChartOptions"
                                    [chartType]="doughnutChartType">
                            </canvas>
                        </div>
                    </div>
                </div>
            </div>


            <!--chart end section-->

            <div class="infograph_title">
                <div class="chart-left">{{project}}</div>
                <div class="chart-right">
                    <img src="assets/images/info_logo.png">
                    <h2>infographic</h2>
                </div>
            </div>

        </div>
    </div>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "rgb(199, 28, 109)" type = "square-loader" [fullScreen] = "true"></ngx-spinner>
</body>
